import useAsyncAction from 'modules/core/hooks/useAsyncAction'

import type ManualIncidence from 'modules/bookkeepers/store/models/ManualIncidence'
import type ManualIncidenceForm from 'modules/payroll_bundle/pages/IncidencesPage/utils/manualIncidenceForm'

const useUpdateManualIncidence = (
  manualIncidenceModel: ManualIncidence,
  form: ManualIncidenceForm,
  handleClose: () => void
) => {
  const { running: loading, performAction: update } = useAsyncAction(async () => {
    await form.save(manualIncidenceModel)
    handleClose()
  })

  return {
    loading,
    update,
  }
}

export default useUpdateManualIncidence
